import { Route, Routes } from "react-router-dom";
// import { ProtectedRoute } from './ProtectedRoute';
import ProtectedRoute from "./ProtectedRoute";
import Login from "../pages/Login";
import "../assets/style/index.scss";
import { Provider } from "react-redux";
import store from "../services/store";
import PostDeals from "../pages/PostDeals";
import PostNews from "../pages/PostNews";
import StoreManager from "../pages/StoreManager";
import MenuConfig from "../pages/MenuConfig";
import CreateAcount from "../pages/CreateAcount";
import AdManager from "../pages/AdManager";
import Statistics from "../pages/Statistics";
import ProductStatistics from "../pages/ProductStatistics";
import BannerStatistics from "../pages/BannerStatistics";
import SurverManager from "../pages/SurveyManager";
import SurveyStatistics from "../pages/SurveyStatistics";
import SurveyDetail from "../pages/SurveyStatistics/SurveyDetail";
import SpamManagement from "../pages/SpamManagement";
import ChatStatistics from "../pages/ChatStatistics";
import ChatWithBkavPro from "../pages/ChatWithBkavPro";
import GroupNotifycation from "../pages/GroupNotifycation";
import TemplatesMessage from "../pages/TemplatesMessage";
export function RootApp() {
  return (
    <Provider store={store}>
      <Routes>
        <Route path="/" element={<ProtectedRoute />}>
          <Route index path="/" element={<PostDeals />} key={"deals"} />
          <Route path="deals" element={<PostDeals />} key={"deals"} />
          <Route path="news" element={<PostNews />} />
          <Route path="storemanager" element={<StoreManager />} />
          <Route path="menuconfig" element={<MenuConfig />} />
          <Route path="createaccount" element={<CreateAcount />} />
          <Route path="deals-statistics" element={<Statistics />} />
          <Route path="admanager" element={<AdManager />} />
          <Route path="news-statistics" element={<Statistics />} />
          <Route path="product-statistics" element={<ProductStatistics />} />
          <Route path="banner-statistics" element={<BannerStatistics />} />
          <Route path="survey_statistics" element={<SurveyStatistics />} />
          <Route path="survey_statistics_detail" element={<SurveyDetail />} />
          <Route path="surveymanager" element={<SurverManager />} />
          <Route path="spam-management" element={<SpamManagement />} />
          {/* Thống kê chat */}
          <Route path="message-statistics" element={<ChatStatistics />} />
          {/* Cấu hình tin nhắn mẫu của nhân viên */}
          <Route path="message-templates" element={<TemplatesMessage />} />
          {/* Gửi thông báo nhóm với Bkav Pro*/}
          <Route path="group-notification" element={<GroupNotifycation />} />
          {/* Chat với Bkav */}
          <Route path="chat-bkav" element={<ChatWithBkavPro />} />
        </Route>
        <Route path="/login" element={<Login />} />
      </Routes>
    </Provider>
  );
}
